import { render, staticRenderFns } from "./LuckyTask.vue?vue&type=template&id=22adaf10&scoped=true&"
import script from "./LuckyTask.vue?vue&type=script&lang=js&"
export * from "./LuckyTask.vue?vue&type=script&lang=js&"
import style0 from "./LuckyTask.vue?vue&type=style&index=0&id=22adaf10&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22adaf10",
  null
  
)

export default component.exports